import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup,  Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { NbToastrService,NbDialogService, NbStepperComponent} from '@nebular/theme';
import { ThirdPartyApplicationsApi } from '../../../@core/backend/common/api/thirdPartyApplications.api';
import { Firstpaymentdialog } from '../../student-verification/payment_dialog/paymentdialog';
import { DocumentViewer } from '../../student-application/dialog/documentViewer.component';
import * as _moment from 'moment';
import { Moment} from 'moment';
import { environment } from '../../../../environments/environment';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { ConfirmationService } from 'primeng/api';
import { ApplicationProcessApi } from '../../../@core/backend/common/api/applicationProcess.api';
import { MatDatepicker } from '@angular/material/datepicker';
import { map, startWith } from 'rxjs/operators';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { saveAs } from 'file-saver';


const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'ngx-third-party-application',
  styleUrls: ['./third-party-application.component.scss'],
  templateUrl : './third-party-application.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ConfirmationService
  ],
})
export class thirdPartyApplicationComponent implements OnInit {

  protected readonly unsubscribe$ = new Subject<void>();
  tabcheck1: Boolean =false;
	tabcheck2: Boolean =false;
	tabcheck3: Boolean =false;
  tabcheck4: Boolean =false;
  loading:Boolean =false;
  verificationData: any = [];
  showError: boolean = false;

  marksheetInput: boolean  =false;
  transcriptInput: boolean =false;
  degreeInput: boolean  =false;
  sealedCoverInput: boolean=false;

  marksheetss:boolean=false;
  transcriptss:boolean=false;
  degree:boolean=false;

  Inmarksheetss: boolean = true;
  Inaadharss: boolean = false;
  Intranscriptss: boolean = false;
  Indegree: boolean = false;
  InsecondYearss: boolean = false;
  serviceType: any;
  courseDetails: any;
  pickupInput : boolean = false;
  selectedVerificationType: any;

  @ViewChild('stepper') stepper: NbStepperComponent;
  date = new Date();
  nextStepper : Boolean = false;
  verificationTypes: any;
  verifyTypes : any;
  courseData: any;
  valueOfPattern:any;
  years_array: number[];
  marksheets : FormGroup;
  transcripts: FormGroup;
  degrees: FormGroup;
  patternValue: any;
  marksheetInstitute : FormGroup;
  degreeInstitute : FormGroup;
  transcriptInstitute : FormGroup;
  max = new Date();
  documentDetails = [];
  activeTab1: boolean = false;
  activeTab2: boolean = false;
  activeTab3: boolean = false;
  uploadUrl = environment.apiUrl;
  imageUrl = environment.imageUrl;
  position: string;
  status: string;
  currenttoken: NbAuthJWTToken;
  loader1: boolean = false;
  loader2: boolean = false;
  loader3: boolean = false;
  isFormValid: boolean = false;
  filteredOptions1: Observable<any[]>[] = [];
  logo : string = "../../../../assets/images/solapur_logo.png";
  pdfImg: string = '../../../assets/images/pdf.png';
  filteredOptions2: Observable<any[]>[] = [];
  filteredOptions3: Observable<any[]>[] = [];
  courseName: any;
  viewInstitute: boolean = true;
  selectedDelivery: any= 'Digital';
  selectedDeliveryMode : any = 'Normal';
  instituteDetails :any;
  personalDetails: any;
  verificationDetails: any;
  marksheetDetails: any;
  transcriptDetails: any;
  degreeDetails: any;
  deliveryOptions: any;
  degreeInstituteDetails: any;
  transcriptInstituteDetails: any;
  marksheetInstituteDetails: any;
  user_id: any;
  secondYearss:boolean=false;
  patterns = [{name : 'Annual'},{name : 'Semester'}]
  courseTypes = [{type :'Regular'},{type :'External'}]
  resultClasses = [{name : 'Distinction'}, {name : 'First Class'},{ name : 'Higher Second Class'},{ name : 'Second Class'},{name : 'Pass Class'},{name : 'Successful'},{name :'Outstanding - Explary'},{name :'Fail/ATKT'}]
  collegeData: any;
  secondYears: FormGroup;
  filteredOptions4: Observable<any[]>[] = [];
  filteredOptions5: Observable<any[]>[] = [];
  secondYearDetails: any;
  secondYearInstituteDetails: any;
  readonly emailValidate = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
  loader: boolean;
  helpEmailId = environment.helpEmailId; //"e-query@gujaratuniversity.ac.in";
  helpMobNo = environment.helpMobNo;
  displayvideo1: any;
  displayvideo2: any;
  displayvideo3: any;
  errorMessage: string;
  aadharDetails: any;
  aadharss: boolean;
  marksheetData: boolean;
  showTranscript: boolean = false;
  showDegreet: boolean = false;
  language: any;
  filteredOptions6: Observable<any[]>[] = [];
  filteredOptions7: Observable<any[]>[] = [];
  filteredOptions8: Observable<any[]>[] = [];
  patternType: string;
  mbaYear: boolean = false;
  coursename:boolean=false;
  college: any;
  cd: any;
  coursevalue: boolean = false;
  semesterVal: any;
  data:any;
  documentData: any;
  pattern_Type: any;
  options  = [{ name: 'Semester I' }, { name: 'Semester II' },{ name: 'Semester III' }, { name: 'Semester IV' },
  { name: 'Semester V' }, { name: 'Semester VI' } ,{ name: 'Semester VII' }, { name: 'Semester VIII' },
  { name: 'First Year' }, { name: 'Second Year' }, { name: 'Third Year' },{ name: 'Fourth Year'}];
  marksheet_fetched_data:boolean[] = [];
  degree_fetched_data:boolean[] = [];
  transcript_fetched_data:boolean[] = [];
  documentDetailInfo: any;
  collegeCourse: any;
  selectedCollege: string;
  collegeId: any;
  selectedcourse: string;
  courseId: any;
  filteredCourses: Observable<[]>;


  constructor( private agentProcessApi : ThirdPartyApplicationsApi,
    private processApi : ApplicationProcessApi,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private confirmationService: ConfirmationService,
    private authService: NbAuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute:ActivatedRoute,
    private fb : FormBuilder) {
      
  }

  ngOnInit(): void {
    this.user_id = this.activatedRoute.snapshot.paramMap.get('user_id');
    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    this.getCourses('');
    this.getColleges();
    
    this.marksheets = this.fb.group({
      marksheet : this.fb.array([]),
      marksheetInstitute : this.fb.array([]),
    })
    this.transcripts = this.fb.group({
      transcript : this.fb.array([]),
      transcriptInstitute : this.fb.array([]),
    })
    this.degrees = this.fb.group({
      degree : this.fb.array([]),
      degreeInstitute : this.fb.array([]),
    })
    this.secondYears = this.fb.group({
      secondYear : this.fb.array([]),
      secondYearInstitute : this.fb.array([]),
    })
    
    this.getVerificationTypes();
    this.getDocumentDetails();
    this.getInstitutionData();
    this.getPreviewData();
    this.checkstepper();
    this.setDocumentTab();
    this.getUploadData();
    this.getDataOfDocument();
    this.language = this.personalDetails.language
  }
    //For Patching value for Supportive Type Course Name
getDataOfDocument(){
  this.agentProcessApi.getDocumentDetails(this.user_id).subscribe(data => {
    if(data['status']==200){
      this.documentData=data['data']
      for(let datas of this.documentData){
        if(datas.type == "transcript"){
          this.courseName =datas.courseName;
        }else{
          this.courseName =datas.courseName;
        }
      }
    }
  })
}

 ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  setDocumentTab(){
    if (this.verificationTypes) {
      if (this.verificationTypes.marksheet == true) {
        this.Marksheets();
        // if(this.marksheetData == true) {
          this.InMarksheets();
        // }
      } else if (this.verificationTypes.marksheet != true && this.verificationTypes.transcript == true) {
        this.Transcripts();
        this.InTranscripts();
      } else if (this.verificationTypes.marksheet != true && this.verificationTypes.transcript != true && this.verificationTypes.degreeCertificate == true) {
        this.Degree();
        this.InDegree();
      } else if (this.verificationTypes.marksheet != true && this.verificationTypes.transcript != true && this.verificationTypes.degreeCertificate != true && this.verificationTypes.secondYear == true) {
        this.secondYear();
        this.InsecondYear();
      } else if (this.verificationTypes.marksheet != true && this.verificationTypes.transcript != true && this.verificationTypes.degreeCertificate != true && this.verificationTypes.secondYear != true) {
        this.checkstepper();
      }
      if (this.verificationTypes.transcript == true && this.verificationTypes.degreeCertificate == true) {
        this.showTranscript = true;
        this.showDegreet = false;
      } else if (this.verificationTypes.transcript == true) {
        this.showTranscript = true
      } else if (this.verificationTypes.degreeCertificate == true) {
        this.showDegreet = true
      }
    } else {
      this.Marksheets();
      this.InMarksheets();
    }
    this.getUploadData();
  }

  checkstepper(){
    this.loader = true;
    this.agentProcessApi.checkStepper(this.user_id).subscribe(data=>{
      this.tabcheck1 = data['data'].tab1;
      this.tabcheck2 = data['data'].tab2;
      this.tabcheck3 = data['data'].tab3;
      this.tabcheck4 = data['data'].tab4;
      // this.tabcheck5 = data['data']['tab5'];
      if(this.tabcheck1 == false){
				setTimeout(()=>{
					this.checkTabs(0);
					
				  },1000); 
				
			}else if(this.tabcheck2 == false){
        
				setTimeout(()=>{
					this.checkTabs(1);
        },1000);
			}else if(this.tabcheck3 == false){
				setTimeout(()=>{
					this.checkTabs(2);
        },1000);
				
			}else{
        setTimeout(()=>{
					this.checkTabs(3);
					// this.toasterService.danger('Fill The Required Details');
				  },1000);
      }
      // this.loadingimg = false;
     
    })
  }

  checkTabs(index) {
    setTimeout(() => {
      switch (index) {
        case 0: {
          if (index < 1) {
            this.stepper.selectedIndex = index;
          } else {
            if (this.tabcheck1 == false) {
              this.stepper.selectedIndex = 0;
            } else {
              this.stepper.selectedIndex = index;
            }
          }
          break;
        }
        case 1: {
          if (index < 2) {
            if (this.tabcheck1 == false) {
              this.stepper.selectedIndex = 0;
            } else {
              this.stepper.selectedIndex = index;
            }
          } else {
            if (this.tabcheck2 == false) {
              this.stepper.selectedIndex = 1;
            } else if (this.tabcheck3 == false) {
              this.stepper.selectedIndex = 2;
            } else if (this.tabcheck4 == false) {
              this.stepper.selectedIndex = 3;
            }
          }
          break;
        }
        case 2: {
          if (index < 3) {
            if (this.tabcheck1 == false) {
              this.stepper.selectedIndex = 0;
            } else if (this.tabcheck2 == false) {
              this.stepper.selectedIndex = 1;
            } else {
              this.stepper.selectedIndex = index;
            }
          } else {
            if (this.tabcheck2 == false) {
              this.stepper.selectedIndex = 1;
            } else if (this.tabcheck3 == false) {
              this.stepper.selectedIndex = 2;
            } else if (this.tabcheck4 == false) {
              this.stepper.selectedIndex = 3;
            }
          }
          break;
        }
        case 3: {
          if (index < 4) {
            if (this.tabcheck1 == false) {
              this.stepper.selectedIndex = 0;
            } else if (this.tabcheck2 == false) {
              this.stepper.selectedIndex = 1;
              this.validateDocumentDetails('documents')
            } else if (this.tabcheck3 == false) {
              this.stepper.selectedIndex = 2;
              this.validateDocumentDetails('institutes')
            } else {
              this.stepper.selectedIndex = index;

            }
          } else {
            if (this.tabcheck1 == false) {
              this.stepper.selectedIndex = 0;
            } else if (this.tabcheck2 == false) {
              this.stepper.selectedIndex = 1;
            } else if (this.tabcheck3 == false) {
              this.stepper.selectedIndex = 2;
            }
          }
          break;
        }
      }
      this.loader = false;
    }, 2000)
  }

  selectVerificationType(event,type){
    this.selectedVerificationType = event.value;
    
    if (event.checked == true || type == 'sealedCover' || type == 'digital' || type == 'pickup') {
      this.verificationData.push({
        type: type,
        event: event.checked
      })
      switch (type) {
        case 'marksheet': this.marksheetInput = true;
          this.verificationTypes.marksheet = true;
          break;
        case 'transcript': this.transcriptInput = true;
          this.verificationTypes.transcript = true;
          // const indexOfObject = this.verificationData.some(object => {
          //   return object.type === 'marksheet';
          // })
          // if (indexOfObject == true) {
          //   this.marksheetData = true;
          // } else {
          //   this.marksheetData = false;
          //   this.verificationData.push({
          //     type: 'marksheet',
          //     event: true
          //   })
          //   this.verificationTypes.marksheet = true;
          //   this.marksheetInput = true;
          // }
          break;
        case 'degreeCertificate': this.degreeInput = true;
          this.verificationTypes.degreeCertificate = true;
          break;
        case 'sealedCover': this.sealedCoverInput = true;
          this.verificationTypes.sealedCover = true;
          this.selectedDelivery = 'Physical';
          this.pickupInput = false;
          break;
        case 'pickup': this.pickupInput = true;
          this.verificationTypes.pickup = true;
          this.selectedDelivery = 'Physical';
          this.sealedCoverInput = false;
          break;
        case 'digital':
          this.verificationTypes.digital = true;
          this.selectedDelivery = 'Digital';
          this.sealedCoverInput = false;
          this.pickupInput = false;
          break;
      }
    } else {
      const indexOfObject = this.verificationData.findIndex(object => {
        return object.type === type;
      })
      this.verificationData.splice(indexOfObject, 1);
      switch (type) {
        case 'marksheet': this.marksheetInput = false;
          var flag = this.verificationData.findIndex(object => {
            return object.type === 'transcript';
          })
          // if (flag == false){
          //   this.verificationTypes.marksheet = false;
          //   this.marksheetData = null;
          // }else{
          //   this.marksheetData = false;
          // }
          //break;
        case 'transcript': this.transcriptInput = false;
          this.verificationTypes.transcript = false;
          // if (this.marksheetData == false) {
          //   this.verificationTypes.marksheet = false;
          // }
          break;
        case 'degreeCertificate': this.degreeInput = false;
          this.verificationTypes.degreeCertificate = false;
          break;
        case 'sealedCover': {
          this.sealedCoverInput = false;
          this.verificationTypes.sealedCover = false;
          this.selectedDelivery = 'Digital';
        }
          break;
        case 'pickup': {
          this.pickupInput = false;
          this.verificationTypes.pickup = false;
          this.selectedDelivery = 'Digital';
        }
          break;
        case 'digital':
          this.verificationTypes.digital = false;
          break;
      }
    }
  }

  documentCount(event,type){
    this.verificationData.forEach(data=>{
      // if(type == data.type){
        data.documentCount = event.target.value;
      // }
    })
  }

  prevStep(){
    this.setDocumentTab();
    this.stepper.previous();
  }

  nextStep(){
    this.loader = true;
    if(this.stepper.selectedIndex == 0){
      this.saveVerificationTypes('');
    }else if(this.aadharDetails?.id == null){
      this.toastrService.show('Please upload AadharCard','PENDING DOCUMENT');
    }else if(this.stepper.selectedIndex == 1){
      this.validateDocumentDetails('documents');
    }else if(this.stepper.selectedIndex == 2){
      this.validateDocumentDetails('institutes');
      this.getPreviewData();
    }else if(this.stepper.selectedIndex == 3){
      this.proceedforpayment();
    }
    setTimeout(()=>{
      this.checkstepper();
    },3000)
  }

  getUploadData(){
    this.agentProcessApi.getSupportiveData(this.user_id).subscribe(data=>{
      if(data['status']==200){
        this.data=data['data']; 
        for (let i = 0; i < this.data.length; i++) {
          this.semesterVal=this.data[i].semester;
      }
      }
    })
  }

  saveVerificationTypes(type){
    this.nextStepper = true;
    var result = false;
    if (type == "deselectTranscript") {
      result = true;
    } else {

      result = this.verificationData.some(data => {
        var result = false;
        if (((data.type == 'marksheet' && (data.documentCount != undefined && data.documentCount != null && data.documentCount != ''  )) ||
        (data.type == 'transcript' && (data.documentCount != undefined && data.documentCount != null && data.documentCount != '' )) ||
        (data.type == 'degreeCertificate' && (data.documentCount != undefined && data.documentCount != null && data.documentCount != '' )))
         && this.selectedVerificationType == 'pickup' ||  this.selectedVerificationType == 'digital' || this.selectedVerificationType == 'sealedCover') {
          result = true;
        } else {
          result = false;
        }
        return result
      })
    }

    if(result == true){
      this.showError = false;
      this.errorMessage = ""
      this.agentProcessApi.saveVerificationTypes(this.verificationData,this.user_id).subscribe(data=>{
        if(data['status'] == 200){
          this.verificationTypes = data['data'];
          this.setDocumentTab();
          this.getDocumentDetails();
          this.getInstitutionData();
          
        }else{
          this.verificationTypes = {
            marksheet: false,
            noOfMarksheet: null,
            transcript: false,
            noOfTranscript: null,
            degreeCertificate: false,
            noOfDegree: null,
            sealedCover: false,
            noOfCopies: null,
            secondYear: false,
            // marksheetData: null
          };
        }
        this.loader = false;
      })
    }else{
      this.showError = true;
      this.errorMessage = "Select any one or more from above options."
    }
  }

  getVerificationTypes(){
    this.nextStepper = true;
    this.loader = true;
    this.agentProcessApi.getVerificationTypes(this.user_id).subscribe(data=>{
      this.loader = false;
      if (data['status'] == 200) {
        this.verificationTypes = data['data'];
        
        this.serviceType = data['deliveryType'];
        
        if (this.verificationTypes) {
          if (this.verificationTypes.marksheet) {
            this.verificationData.push({
              type: 'marksheet',
              documentCount: this.verificationTypes.noOfMarksheet
            })
            this.marksheetInput = true;
          }
          if (this.verificationTypes.transcript) {
            this.verificationData.push({
              type: 'transcript',
              documentCount: this.verificationTypes.noOfTranscript
            })
            this.transcriptInput = true;
          }
          if (this.verificationTypes.degreeCertificate) {
            this.verificationData.push({
              type: 'degreeCertificate',
              documentCount: this.verificationTypes.noOfDegree,
              
            })
            this.degreeInput = true;
            //this.degreeTypeCtrl.setValue(this.verificationTypes.degree_Type);
          }
          if (this.verificationTypes.sealedCover) {
            this.verificationData.push({
              type: 'sealedCover',
              documentCount: this.verificationTypes.noOfCopies
            })
            this.selectedDelivery = "Physical";
            this.sealedCoverInput = true;
          }
          if (this.verificationTypes.secondYear) {
            this.verificationData.push({
              type: 'secondYear'
            })
          }

          if (this.verificationTypes.pickup){
            this.verificationData.push({
              type: 'pickup',
              documentCount: this.verificationTypes.noOfPickup
            })
            this.selectedDelivery = "Physical";
            this.pickupInput = true;
          }
          if (this.verificationTypes.digital){
            this.verificationData.push({
              type: 'digital',
            })
          
          }
          // this.marksheetData = this.verificationTypes.marksheetData;
          this.setDocumentTab();

        } else {
          this.verificationTypes = {
            marksheet: false,
            noOfMarksheet: null,
            transcript: false,
            noOfTranscript: null,
            degreeCertificate: false,
            noOfDegree: null,
            sealedCover: false,
            noOfCopies: null,
            secondYear: false,
            // marksheetData: null
          };
        }

      } else {
        this.verificationTypes = {
          marksheet: false,
          noOfMarksheet: null,
          transcript: false,
          noOfTranscript: null,
          degreeCertificate: false,
          noOfDegree: null,
          sealedCover: false,
          noOfCopies: null,
          secondYear: false,
          // marksheetData: null
        };
      }
      this.loader1 = false;
      
    }) 
  }

  buildItem(type,val1,val2,val3,val4,val5,val6,val7,val8,val9,val10,val11,val12,val13,val14,val15,val16,val17,val18,val19, val20,val21,val22,val23,val24,val25,val26,val27){
    if (type == 'marksheet') {
      return new FormGroup({
        id: new FormControl(val1),
        collegeName: new FormControl(val10, Validators.required),
        courseName: new FormControl(val2, Validators.required),
        courseType: new FormControl(val19, Validators.required),
        pattern: new FormControl(val9, Validators.required),
        semester: new FormControl(val8, Validators.required),
        seatNo: new FormControl(val3, Validators.required),
        passingMonthYear: new FormControl(val4, Validators.required),
        fileName: new FormControl(val6),
        result: new FormControl(val7),
        fromMonthYear: new FormControl(val11),
        toMonthYear: new FormControl(val12),
        totalGrade : new FormControl(val21),
        avgGrade : new FormControl(val22),
        majorSubject : new FormControl(val13),
        mbaCheck : new FormControl(val23),
        prnMarksheet : new FormControl(val24),
        marksheetControl : new FormControl(val27)
      })
    }
    if (type == 'transcript') {
      return new FormGroup({
        id: new FormControl(val1),
        collegeName: new FormControl(val10, Validators.required),
        courseName: new FormControl(val2, Validators.required),
        courseType: new FormControl(val19, Validators.required),
        seatNo: new FormControl(val3, Validators.required),
        passingMonthYear: new FormControl(val4, Validators.required),
        fileName: new FormControl(val6),
        result: new FormControl(val7, Validators.required),
        courseSelect : new FormControl(val14),
        prnTranscipt : new FormControl(val25)
      })
    }
    if (type == 'degree') {
      return new FormGroup({
        id: new FormControl(val1),
        collegeName: new FormControl(val10, Validators.required),
        courseName: new FormControl(val2, Validators.required),
        courseType: new FormControl(val19, Validators.required),
        seatNo: new FormControl(val3, Validators.required),
        passingMonthYear: new FormControl(val4, Validators.required),
        convocationDate: new FormControl(val5),
        result: new FormControl(val7, Validators.required),
        fileName: new FormControl(val6),
        degreeTypeCtrl: new FormControl(val20, Validators.required),
        courseSelect : new FormControl(val14),
        fileName_ICC : new FormControl(val15),
        id_ICC : new FormControl(val16),
        icc_flag : new FormControl(val17),
        ic_certificate : new FormControl(val18),
        prnDegree : new FormControl(val26)
      })
    }
    if (type == 'secondYear') {
      return new FormGroup({
        id: new FormControl(val1),
        courseName: new FormControl(val2, Validators.required),
        courseType: new FormControl(val19, Validators.required),
        collegeName: new FormControl(val10, Validators.required),
        pattern: new FormControl(val9, Validators.required),
        fromMonthYear: new FormControl(val11, Validators.required),
        toMonthYear: new FormControl(val12, Validators.required),
        passingMonthYear: new FormControl(val4, Validators.required),
        passingMonthYear2: new FormControl(val17),
        result: new FormControl(val7, Validators.required),
        result2: new FormControl(val18),
        fileName: new FormControl(val6),
        fileName2: new FormControl(val15),
        fileName3: new FormControl(val16),
        majorSubject: new FormControl(val13, Validators.required),
        subsidarySubject: new FormControl(val14, Validators.required)
      })
    }
  }

  getCourses(college){
    this.processApi.getCourses(college).subscribe(data=>{
      this.courseData = data['data'];
    })
  }

  getColleges(){
    this.processApi.getColleges().subscribe(data=>{
      this.collegeCourse = data['data'].college_course
      this.collegeData = data['data'].college;
    })
  }

  chosenMonthHandler(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>,type,index,subtype) {
    if(type == 'marksheet'){
      switch (subtype) {
        case "from": {
          const ctrlValue1 = moment((<FormArray>this.marksheets.controls['marksheet']).at(index).value.fromMonthYear)
          ctrlValue1.month(normalizedMonthAndYear.month());
          ctrlValue1.year(normalizedMonthAndYear.year());
          (<FormArray>this.marksheets.controls['marksheet']).at(index).patchValue({ 'fromMonthYear': ctrlValue1 })
          datepicker.close();
        }
          break;
        case "to": {
          const ctrlValue2 = moment((<FormArray>this.marksheets.controls['marksheet']).at(index).value.toMonthYear);
          ctrlValue2.month(normalizedMonthAndYear.month());
          ctrlValue2.year(normalizedMonthAndYear.year());
          (<FormArray>this.marksheets.controls['marksheet']).at(index).patchValue({ 'toMonthYear': ctrlValue2 })
          datepicker.close();
        }
          break;
        case "passing": {
          const ctrlValue = moment((<FormArray>this.marksheets.controls['marksheet']).at(index).value.passingMonthYear);
          ctrlValue.month(normalizedMonthAndYear.month());
          ctrlValue.year(normalizedMonthAndYear.year());
          var passingYear = normalizedMonthAndYear.year();
          if(((<FormArray>this.marksheets.controls['marksheet']).at(index).value.courseName.includes('Master in Business Administration') || 
          (<FormArray>this.marksheets.controls['marksheet']).at(index).value.courseName.includes('Master of Business Administration'))
          && ((<FormArray>this.marksheets.controls['marksheet']).at(index).value.semester === 'Semester IV' ||
          (<FormArray>this.marksheets.controls['marksheet']).at(index).value.semester === 'Second Year')){
            if(passingYear >=1995 && passingYear <=2003){
              (<FormArray>this.marksheets.controls['marksheet']).at(index).patchValue({'mbaCheck':true});
            }else{
              (<FormArray>this.marksheets.controls['marksheet']).at(index).patchValue({'mbaCheck':false});
            }
          }
          

          (<FormArray>this.marksheets.controls['marksheet']).at(index).patchValue({ 'passingMonthYear': ctrlValue })
          datepicker.close();
        }
          break;
        
      }
    }else if(type == 'transcript'){
      const ctrlValue = moment((<FormArray>this.transcripts.controls['transcript']).at(index).value.passingMonthYear);
      ctrlValue.month(normalizedMonthAndYear.month());
      ctrlValue.year(normalizedMonthAndYear.year());
      (<FormArray>this.transcripts.controls['transcript']).at(index).patchValue({'passingMonthYear' : ctrlValue})
      datepicker.close();
    }else if(type == 'degree'){
      const ctrlValue = moment((<FormArray>this.degrees.controls['degree']).at(index).value.passingMonthYear);
      ctrlValue.month(normalizedMonthAndYear.month());
      ctrlValue.year(normalizedMonthAndYear.year());
      (<FormArray>this.degrees.controls['degree']).at(index).patchValue({'passingMonthYear' : ctrlValue})
      datepicker.close();
    }else if(type == 'secondYear'){
      switch(subtype){
        case "from": {
          const ctrlValue1 = moment((<FormArray>this.secondYears.controls['secondYear']).at(index).value.fromMonthYear)
          ctrlValue1.month(normalizedMonthAndYear.month());
          ctrlValue1.year(normalizedMonthAndYear.year());
          (<FormArray>this.secondYears.controls['secondYear']).at(index).patchValue({'fromMonthYear' : ctrlValue1})
          datepicker.close();

        }
        break;
        case "to": {
          const ctrlValue2 = moment((<FormArray>this.secondYears.controls['secondYear']).at(index).value.toMonthYear);
          ctrlValue2.month(normalizedMonthAndYear.month());
          ctrlValue2.year(normalizedMonthAndYear.year());
          (<FormArray>this.secondYears.controls['secondYear']).at(index).patchValue({'toMonthYear' : ctrlValue2})
          datepicker.close();
        }
        break;
        case "passing": {
          const ctrlValue3 = moment((<FormArray>this.secondYears.controls['secondYear']).at(index).value.passingMonthYear);
          ctrlValue3.month(normalizedMonthAndYear.month());
          ctrlValue3.year(normalizedMonthAndYear.year());
          (<FormArray>this.secondYears.controls['secondYear']).at(index).patchValue({'passingMonthYear' : ctrlValue3})
          datepicker.close();
        }
        break;
        case "passing2": {
          const ctrlValue = moment((<FormArray>this.secondYears.controls['secondYear']).at(index).value.passingMonthYear2);
          ctrlValue.month(normalizedMonthAndYear.month());
          ctrlValue.year(normalizedMonthAndYear.year());
          (<FormArray>this.secondYears.controls['secondYear']).at(index).patchValue({'passingMonthYear2' : ctrlValue})
          datepicker.close();
        }
        break;
      }
    }
  }

  onSelect($event: any): void {
    var maxFileSize =  5000000;
    var imgArr = $event.files[0].name.split('.');
    var extension = imgArr[imgArr.length - 1].trim();
    if ($event.files[0].size > maxFileSize) {
      this.confirmationService.confirm({
        message: 'Maximum file size should be 5 MB.',
        header: 'Invalid File Size',
        icon: 'pi pi-info-circle',
        rejectVisible : false,
        acceptLabel: 'Ok'
      });
    }
    
    if((extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='JPG' && extension!='JPEG' && extension!='PNG' && extension!='pdf' && extension!='PDF') ) {
      this.confirmationService.confirm({
        message: 'Please upload your transcript in .jpeg or .jpg or .png or .pdf formats',
        header: 'Invalid File Type',
        icon: 'pi pi-info-circle',
        rejectVisible : false,
        acceptLabel: 'Ok'
      });
    }
    
    if((extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='JPG' && extension!='JPEG' && extension!='PNG' && extension!='pdf' && extension!='PDF') ) {
      this.confirmationService.confirm({
        message: 'Please upload your transcript in .jpeg or .jpg or .png or .pdf formats',
        header: 'Invalid File Type',
        icon: 'pi pi-info-circle',
        rejectVisible : false,
        acceptLabel: 'Ok'
      });
    }

  }

  onBeforeSend(event,i) {
    //this.loadingimg = true;
    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        this.currenttoken = token;
        event.xhr.setRequestHeader("Authorization", `Bearer ` + this.currenttoken);
      }
    });
  }

  checkFormValidity(){
    this.isFormValid = this.pattern_Type
  }

  onUpload(event) {
    this.checkFormValidity()
    const reader = new FileReader();
    var duration = 10000;
    this.position = 'top-right';
    this.status = 'success';
    if (event.files && event.files.length) {
      const [file] = event.files;
      reader.readAsDataURL(file);
      var json = event.originalEvent.body;

      var yourData = json.Data; // or json["Data"]
      var yourStatus = json.status;
      var yourMessage = json.message; // or json["Data"]
      if (yourStatus == 200) {
        this.status = 'success';
        this.toastrService.show(yourMessage, 'SUCCESS', { duration });
        this.getDocumentDetails();
        this.getUploadData();
      } else if (yourStatus == 401) {
        this.status = 'error';
        this.toastrService.show(
          yourMessage, 'ERROR', {
          duration
        }
        );
        this.getDocumentDetails();
      } else if (yourStatus == 400) {
        this.status = 'error';
        this.toastrService.show(yourMessage, 'ERROR', {
          duration
        }
        );
        this.getDocumentDetails();
      }
    }
  }

  saveDocumentsDetails(type,index){
    this.loader = true;
    if(type == 'marksheet'){
      if((<FormArray>this.marksheets.controls['marksheet']).at(index).status == 'VALID'){
        var control =  this.marksheets.get('marksheet') as FormArray;
        var marksheet = control.at(index).value;
        if (this.college != undefined && this.coursename != false) {
          this.agentProcessApi.saveDocumentDetails(type,marksheet,this.user_id,this.courseId,this.collegeId).subscribe(data=>{
          
            this.getDocumentDetails();
            this.toastrService.show('Data saved sucessfully ','SUCCESS', { 'duration':3000} )
          })
        } else {
          if(this.coursename == false){
            this.toastrService.danger('Error', 'Please select Course from Course list', { duration: 6000 });
          }else if(this.college == undefined){
            this.toastrService.danger('Error', 'Please select College from College list', { duration: 6000 });
          }
          this.getDocumentDetails();

        }
        
       
      }else{
       this.toastrService.show('Something went wrong ','DANGER', { 'duration':3000} );
      }
    }else if(type == 'transcript'){
      if((<FormArray>this.transcripts.controls['transcript']).at(index).status == 'VALID'){
        var control =  this.transcripts.get('transcript') as FormArray;
        var transcript = control.at(index).value;
        if (this.college != undefined && this.coursename != false) {
          this.agentProcessApi.saveDocumentDetails(type,transcript,this.user_id,this.courseId,this.collegeId).subscribe(data=>{
            this.getDocumentDetails();
            this.toastrService.show('Data saved sucessfully ','SUCCESS', { 'duration':3000} )
          })
          this.getDataOfDocument();
        } else {
          if(this.coursename == false){
            this.toastrService.danger('Error', 'Please select Course from Course list', { duration: 6000 });
          }else if(this.college == undefined){
            this.toastrService.danger('Error', 'Please select College from College list', { duration: 6000 });
          }
          this.getDocumentDetails();
        }
        
      }else{
       this.toastrService.show('Something went wrong ','DANGER', { 'duration':3000} );
      }
    }else if(type == 'degree'){
      if((<FormArray>this.degrees.controls['degree']).at(index).status == 'VALID'){
        var control =  this.degrees.get('degree') as FormArray;
        var degree = control.at(index).value;
        if (this.degrees.get('degree')['controls'][index].get('degreeTypeCtrl').value === 'Degree Certificate') {

          var convocationDate = control.at(index).get('convocationDate').value;


          if (convocationDate === null || convocationDate === '') {
            this.toastrService.danger('Error', 'Please provide a convocation date', { duration: 6000 });
            return;
          }
        }
        if (this.college != undefined && this.coursename != false) {
          this.agentProcessApi.saveDocumentDetails(type,degree,this.user_id,this.courseId,this.collegeId).subscribe(data=>{
            this.getDocumentDetails();
            this.toastrService.show('Data saved sucessfully ','SUCCESS', { 'duration':3000} )
            this.getDataOfDocument();
          })
        } else {
          if(this.coursename == false){
            this.toastrService.danger('Error', 'Please select Course from Course list', { duration: 6000 });
          }else if(this.college == undefined){
            this.toastrService.danger('Error', 'Please select College from College list', { duration: 6000 });
          }
          this.getDocumentDetails();
          this.getDataOfDocument();
        }
        
      }else{
       this.toastrService.show('Something went wrong ','DANGER', { 'duration':3000} );
      }
    }else if(type == 'secondYear'){
      if((<FormArray>this.secondYears.controls['secondYear']).at(index).status == 'VALID'){
        var control =  this.secondYears.get('secondYear') as FormArray;
        var degree = control.at(index).value;
        if (this.college != undefined && this.coursename != false) {
          this.agentProcessApi.saveDocumentDetails(type,degree,this.user_id,this.courseId,this.collegeId).subscribe(data=>{
            this.getDocumentDetails();
            this.toastrService.show('Data saved sucessfully ','SUCCESS', { 'duration':3000} )
          })
        } else {
          if(this.coursename == false){
            this.toastrService.danger('Error', 'Please select Course from Course list', { duration: 6000 });
          }else if(this.college == undefined){
            this.toastrService.danger('Error', 'Please select College from College list', { duration: 6000 });
          }
          this.getDocumentDetails();

        }
        
      }else{
       this.toastrService.show('Something went wrong ','DANGER', { 'duration':3000} );
      }
    }
    this.loader = false;
  }

  changeDeliveryMode(){
    this.viewInstitute = false;
  }

  getDocumentDetails(){
    this.loader = true;
    var marklist_last_data = { collegeName: null, courseName: null, courseType: null, seatNo: null, passingMonthYear: null, semester: null, result: null };
    var transcript_last_data = { collegeName: null, courseName: null, courseType: null, seatNo: null, passingMonthYear: null, semester: null, result: null };
    var degree_last_data = { collegeName: null, courseName: null, courseType: null, seatNo: null, passingMonthYear: null, semester: null, result: null };

    (this.marksheets.controls['marksheet'] as FormArray).clear();
    (this.transcripts.controls['transcript'] as FormArray).clear();
    (this.degrees.controls['degree'] as FormArray).clear();
    (this.secondYears.controls['secondYear'] as FormArray).clear();
    this.agentProcessApi.getDocumentDetails(this.user_id).subscribe(data=>{
      
      if (data['status'] == 200) {
        this.aadharDetails = data['aadhardata'];
        this.documentDetailInfo = data['data']
        // for(let i = 0 ; i  < this.documentDetailInfo.length ; i++){
        //   this.fetched_data[i] = true;
        // }
        var marksheetCount = 0;
        var transcriptCount = 0;
        var degreeCount = 0;
        var secondYearCount = 0;
        data['data'].forEach(data => {
          let doc_id=data.id
          if (data.type == 'marksheet') {
            var selectedpattern;
            if (data.semester.includes('Year')) {
              selectedpattern = 'Annual';
            } else if (data.semester.includes('Semester')) {
              selectedpattern = 'Semester';
            }

            if(data.coursename )
              this.coursename = true;

            var mbaCheck = false;
            if((data.courseName.includes('Master of Business Administration') || data.courseName.includes('Master in Business Administration'))
            && (data.semester == 'Semester IV' || data.semester == 'Second Year'))
            {
              var year = new Date(data.passingMonthYear).getFullYear();
              if(year >= 1995 && year <=2003){
                mbaCheck = true;
              }
            } 
            (<FormArray>this.marksheets.controls['marksheet']).push(this.buildItem('marksheet', data.id, data.courseName, data.seatNo, new Date(data.passingMonthYear), null, data.fileName, data.result, data.semester, selectedpattern, data.collegeName, new Date(data.fromMonthYear), new Date(data.toMonthYear), data.majorSubject, null, null, null, null, null, data.courseType,null,data.totalGrade,data.avgGrade,mbaCheck,data.prn,'','',null));
            var control = <FormArray>this.marksheets.controls['marksheet']
            this.manageNameControl(control.length - 1, 'marksheet');
            marksheetCount += 1;
            marklist_last_data.collegeName = data.collegeName;
            marklist_last_data.courseName = data.courseName;
            marklist_last_data.courseType = data.courseType;
            marklist_last_data.seatNo = data.seatNo;
            marklist_last_data.passingMonthYear = data.passingMonthYear;
            marklist_last_data.semester = data.semester;
            marklist_last_data.result = data.result;
          } else if (data.type == 'transcript') {
            (<FormArray>this.transcripts.controls['transcript']).push(this.buildItem('transcript', data.id, data.courseName, data.seatNo, new Date(data.passingMonthYear), null, data.fileName, data.result, null, null, data.collegeName, null, null, null, null, null, null, null, null, data.courseType,null,null,null,null,'',data.prn,'',null));
            var control = <FormArray>this.transcripts.controls['transcript']
            this.manageNameControl(control.length - 1, 'transcript');
            transcriptCount += 1;
            // transcript_last_data.collegeName = data.collegeName;
            // transcript_last_data.courseName = data.courseName;
            // transcript_last_data.seatNo = data.seatNo;
            // transcript_last_data.passingMonthYear = data.passingMonthYear;
            // transcript_last_data.result = data.result;
          } else if (data.type == 'degree') {
            (<FormArray>this.degrees.controls['degree']).push(this.buildItem('degree', data.id, data.courseName, data.seatNo, new Date(data.passingMonthYear), new Date(data.convocationDate), data.fileName, data.result, null, null, data.collegeName, null, null, null, null, null, null, null, null, data.courseType,data.degreeTypeCtrl,null,null,null,'','',data.prn,null));
            var control = <FormArray>this.degrees.controls['degree']
            this.manageNameControl(control.length - 1, 'degree');
            degreeCount += 1;
            // degree_last_data.collegeName = data.collegeName;
            // degree_last_data.courseName = data.courseName;
            // degree_last_data.seatNo = data.seatNo;
            // degree_last_data.passingMonthYear = data.passingMonthYear;
            // degree_last_data.result = data.result;
          }
          else if (data.type == 'secondYear') {
            var selectedpattern;
            if (data.semester.includes('Semester')) {
              selectedpattern = 'Semester';
            } else {
              selectedpattern = 'Annual';
            }
            (<FormArray>this.secondYears.controls['secondYear']).push(this.buildItem('secondYear', data.id, data.courseName, null, new Date(data.passingMonthYear), null, data.fileName, data.result, null, selectedpattern, data.collegeName, new Date(data.fromMonthYear), new Date(data.toMonthYear), data.majorSubject, data.subsidarySubject, data.fileName2, data.fileName3, new Date(data.passingMonthYear2), data.result2, data.courseType,null,null,null,null,'','','',null));
            var control = <FormArray>this.secondYears.controls['secondYear']
            this.manageNameControl(control.length - 1, 'secondYear');
            secondYearCount += 1;
          }
        })

        setTimeout(() => {
          var last_sem;
          if (this.verificationTypes) {
            if (marklist_last_data.semester != null) {
              var pattern;
              if (marklist_last_data.semester.includes('Year')) {
                pattern = "Annual";
              } else if (marklist_last_data.semester.includes('Semester')) {
                pattern = "Semester";
              }
              this.processApi.getCourseDetails(marklist_last_data.courseName, pattern).subscribe(data => {
                this.courseDetails = data['data'];
                last_sem = this.courseDetails[this.courseDetails.length - 1].term_name;
              });
            }
            setTimeout(() => {
              if (this.verificationTypes.marksheet == true) {
                var count = this.verificationTypes.noOfMarksheet;
                if (marksheetCount < count) {
                  while (count > marksheetCount) {
                    (<FormArray>this.marksheets.controls['marksheet']).push(this.buildItem('marksheet', null, marklist_last_data.courseName, '', new Date(), null, null, null, null, pattern, marklist_last_data.collegeName, new Date(), new Date(), null, null, null, null, null, null, marklist_last_data.courseType,null,null,null,false,'','','',null));
                    var control = <FormArray>this.marksheets.controls['marksheet'];
                    this.manageNameControl(control.length - 1, 'marksheet');
                    count--;
                  }
                }
              }
              if (this.verificationTypes.transcript == true) {
                var count = this.verificationTypes.noOfTranscript;

                if (transcriptCount < count) {
                  if (transcript_last_data.courseName == null) {
                    if (marklist_last_data.semester != null) {
                      if (last_sem == marklist_last_data.semester) {
                        transcript_last_data = marklist_last_data;
                      } else {
                        transcript_last_data.collegeName = marklist_last_data.collegeName;
                        transcript_last_data.courseName = marklist_last_data.courseName;
                        transcript_last_data.courseType = marklist_last_data.courseType;
                        transcript_last_data.seatNo = null;
                        transcript_last_data.passingMonthYear = new Date();
                        transcript_last_data.result = null;
                      }
                    } else if (marklist_last_data.courseType != null) {
                      transcript_last_data.collegeName = marklist_last_data.collegeName;
                      transcript_last_data.courseName = marklist_last_data.courseName;
                      transcript_last_data.courseType = marklist_last_data.courseType;
                      transcript_last_data.seatNo = null;
                      transcript_last_data.passingMonthYear = new Date();
                      transcript_last_data.result = null;
                    } else if (marklist_last_data.courseName != null) {
                      transcript_last_data.collegeName = marklist_last_data.collegeName;
                      transcript_last_data.courseName = marklist_last_data.courseName;

                      transcript_last_data.seatNo = null;
                      transcript_last_data.passingMonthYear = new Date();
                      transcript_last_data.result = null;
                    }
                    else if (marklist_last_data.collegeName != null) {
                      transcript_last_data.collegeName = marklist_last_data.collegeName;
                      transcript_last_data.courseName = null;
                      transcript_last_data.seatNo = null;
                      transcript_last_data.passingMonthYear = new Date();
                      transcript_last_data.result = null;
                    }
                  }
                  while (count > transcriptCount) {
                    (<FormArray>this.transcripts.controls['transcript']).push(this.buildItem('transcript', null, transcript_last_data.courseName, transcript_last_data.seatNo, new Date(transcript_last_data.passingMonthYear), null, null, transcript_last_data.result, null, null, transcript_last_data.collegeName, null, null, null, null, null, null, null, null, transcript_last_data.courseType,null,null,null,null,'','','',null));
                    var control = <FormArray>this.transcripts.controls['transcript'];
                    this.manageNameControl(control.length - 1, 'transcript');
                    count--;
                  }
                }
              }
              if (this.verificationTypes.degreeCertificate == true) {
                var count = this.verificationTypes.noOfDegree;

                if (degreeCount < count) {
                  if (degree_last_data.courseName == null) {
                    if (transcript_last_data.courseName != null) {
                      degree_last_data = transcript_last_data
                    } else {
                      if (marklist_last_data.semester != null) {
                        if (last_sem == marklist_last_data.semester) {
                          degree_last_data = marklist_last_data;
                        } else {
                          degree_last_data.collegeName = marklist_last_data.collegeName;
                          degree_last_data.courseName = marklist_last_data.courseName;
                          degree_last_data.courseType = marklist_last_data.courseType;
                          degree_last_data.seatNo = null;
                          degree_last_data.passingMonthYear = new Date();
                          degree_last_data.result = null;
                        }
                      } else if (marklist_last_data.courseType != null) {
                        degree_last_data.collegeName = marklist_last_data.collegeName;
                        degree_last_data.courseName = marklist_last_data.courseName;
                        degree_last_data.courseType = marklist_last_data.courseType;
                        degree_last_data.seatNo = null;
                        degree_last_data.passingMonthYear = new Date();
                        degree_last_data.result = null;
                      } else if (marklist_last_data.courseName != null) {
                        degree_last_data.collegeName = marklist_last_data.collegeName;
                        degree_last_data.courseName = marklist_last_data.courseName;
                        degree_last_data.seatNo = null;
                        degree_last_data.passingMonthYear = new Date();
                        degree_last_data.result = null;
                      } else if (marklist_last_data.collegeName != null) {
                        degree_last_data.collegeName = marklist_last_data.collegeName;
                        degree_last_data.courseName = null;
                        degree_last_data.seatNo = null;
                        degree_last_data.passingMonthYear = new Date();
                        degree_last_data.result = null;
                      }
                    }
                  }
                  while (count > degreeCount) {
                    (<FormArray>this.degrees.controls['degree']).push(this.buildItem('degree', null, degree_last_data.courseName, degree_last_data.seatNo, new Date(degree_last_data.passingMonthYear), null, null, degree_last_data.result, null, null, degree_last_data.collegeName, null, null, null, null, null, null, null, null, degree_last_data.courseType,null,null,null,null,'','','',null));
                    var control = <FormArray>this.degrees.controls['degree'];
                    this.manageNameControl(control.length - 1, 'degree');
                    count--;
                  }
                }
              }
              if (this.verificationTypes.secondYear == true) {
                var count;
                count = 1;
                if (secondYearCount < count) {
                  while (count > secondYearCount) {
                    (<FormArray>this.secondYears.controls['secondYear']).push(this.buildItem('secondYear', null, null, '', new Date(), null, null, null, null, null, null, new Date(), new Date(), null, null, null, null, new Date(), null, null,null,null,null,null,'','','',null));
                    var control = <FormArray>this.secondYears.controls['secondYear'];
                    this.manageNameControl(control.length - 1, 'secondYear');
                    count--;
                  }
                }
              }
            }, 2000)
          }
          this.loader = false;
        }, 3000)

        this.validateDocumentDetails('documents');
      }
      
    })
  }

  manageNameControl(index: number,type) {
    if(type == 'marksheet'){
      var arrayControl = this.marksheets.controls['marksheet'] as FormArray;
      this.filteredOptions6[index] = arrayControl.at(index).get('collegeName').valueChanges
      .pipe(
        startWith<any>(''),
        map(collegeName =>this._filter('college',collegeName))
      )
      this.filteredOptions1[index] = arrayControl.at(index).get('courseName').valueChanges
      .pipe(
        startWith<any>(''),
        map(courseName => this._filter('course',courseName))
      )

    }else if(type == 'transcript'){
      var arrayControl = this.transcripts.controls['transcript'] as FormArray;
      this.filteredOptions7[index] = arrayControl.at(index).get('collegeName').valueChanges
      .pipe(
        startWith<any>(''),
        map(collegeName =>this._filter('college',collegeName))
      )
      this.filteredOptions2[index] = arrayControl.at(index).get('courseName').valueChanges
      .pipe(
        startWith<any>(''),
        map(courseName => this._filter('course',courseName))
      )

    }else if(type == 'degree'){
      var arrayControl = this.degrees.controls['degree'] as FormArray;
      this.filteredOptions8[index] = arrayControl.at(index).get('collegeName').valueChanges
      .pipe(
        startWith<any>(''),
        map(collegeName =>this._filter('college',collegeName))
      )
      this.filteredOptions3[index] = arrayControl.at(index).get('courseName').valueChanges
      .pipe(
        startWith<any>(''),
        map(courseName => this._filter('course',courseName))
      )

    }else if(type == 'secondYear'){
      var arrayControl = this.secondYears.controls['secondYear'] as FormArray;
      this.filteredOptions5[index] = arrayControl.at(index).get('collegeName').valueChanges
      .pipe(
        startWith<any>(''),
        map(collegeName =>this._filter('college',collegeName))
      )
      this.filteredOptions4[index] = arrayControl.at(index).get('courseName').valueChanges
      .pipe(
        startWith<any>(''),
        map(courseName =>this._filter('course',courseName))
      )

    }
    
    
  }

  private _filter(type,value: string){
    //return this.courseData.filter((s) => new RegExp(value, 'gi').test(s.name));
    if(type=='course'){
      const filterValue = this._normalizeValue(value);
      return this.courseData.filter(option =>
        option.course_name.toLowerCase().includes(filterValue)
      );
    }else if(type =='college'){
      const filterValue = this._normalizeValue(value);
      return this.collegeData.filter(option =>
        option.college_name.toLowerCase().includes(filterValue)
      );
    }
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, "");
  }

  getInstitutionData(){
    this.loader = true;
    (this.marksheets.controls['marksheetInstitute'] as FormArray).clear();
    (this.transcripts.controls['transcriptInstitute'] as FormArray).clear();
    (this.degrees.controls['degreeInstitute'] as FormArray).clear();
    (this.secondYears.controls['secondYearInstitute'] as FormArray).clear();
    this.agentProcessApi.getInstitutionDetails(this.user_id).subscribe(data=>{
      if(data['status'] == 200){
        this.loader = false;
        if(data['data'].length > 0){
          //this.selectedDelivery = data['data'][0].deliveryOption;
          this.selectedDeliveryMode = data['data'][0].deliveryMode;
          this.viewInstitute = true;
        }
        var marksheetCount = 0;
        var transcriptCount = 0;
        var degreeCount = 0;
        var secondYearCount = 0;
        var marklist_last_data ={referenceNO : null, name:null, address:null, email:null};
        var transcript_last_data ={referenceNO : null, name:null, address:null, email:null};
        var degree_last_data ={referenceNO : null, name:null, address:null, email:null};
        var secondYear_last_data ={referenceNO : null, name:null, address:null, email:null};
        data['data'].forEach(data =>{
          switch(data.type){
            case "marksheet":{
              (<FormArray>this.marksheets.controls['marksheetInstitute']).push(this.buildInstituteItems('marksheet',data.id,data.referenceNo,data.name,data.address,data.email,data.deliveryOption));
              marksheetCount += 1;
              marklist_last_data.referenceNO = data.referenceNo;
              marklist_last_data.name = data.name;
              marklist_last_data.address = data.address;
              marklist_last_data.email = data.email;
            }
            break;
            case "transcript":{
              (<FormArray>this.transcripts.controls['transcriptInstitute']).push(this.buildInstituteItems('transcript',data.id,data.referenceNo,data.name,data.address,data.email,data.deliveryOption));
              transcriptCount += 1;
              transcript_last_data.referenceNO = data.referenceNo;
              transcript_last_data.name = data.name;
              transcript_last_data.address = data.address;
              transcript_last_data.email = data.email;
            }
            break;
            case "degree":{
              (<FormArray>this.degrees.controls['degreeInstitute']).push(this.buildInstituteItems('degree',data.id,data.referenceNo,data.name,data.address,data.email,data.deliveryOption));
              degreeCount += 1;
              degree_last_data.referenceNO = data.referenceNo;
              degree_last_data.name = data.name;
              degree_last_data.address = data.address;
              degree_last_data.email = data.email;
            }
            break;
            case "secondYear":{
              (<FormArray>this.secondYears.controls['secondYearInstitute']).push(this.buildInstituteItems('secondYear',data.id,data.referenceNo,data.name,data.address,data.email,data.deliveryOption));
              secondYearCount += 1;
              secondYear_last_data.referenceNO = data.referenceNo;
              secondYear_last_data.name = data.name;
              secondYear_last_data.address = data.address;
              secondYear_last_data.email = data.email;
            }
            break;
          }
        })
        setTimeout(()=>{

            if(this.verificationTypes.marksheet){
              var mcount = 0;
              if (this.verificationTypes.sealedCover) {
                mcount = this.verificationTypes.noOfCopies;
            } else if (this.verificationTypes.pickup) {
                mcount = this.verificationTypes.noOfPickup;
            } else {
                mcount = 1; 
            }
            
              while(mcount > marksheetCount){
                (<FormArray>this.marksheets.controls['marksheetInstitute']).push(this.buildInstituteItems('marksheet',null,marklist_last_data.referenceNO,marklist_last_data.name,marklist_last_data.address,marklist_last_data.email,this.selectedDelivery));
                mcount--;
              }
            }
            
            if(this.verificationTypes.transcript){
              if(transcript_last_data.referenceNO == null){
                if( marklist_last_data.referenceNO != null){
                  transcript_last_data = marklist_last_data;
                }
              }
              var tcount = 0;
              if(this.verificationTypes.sealedCover){

                tcount = this.verificationTypes.noOfCopies;
              }else if (this.verificationTypes.pickup) {
                tcount = this.verificationTypes.noOfPickup;
              } else {
                tcount = 1;
              }
              setTimeout(()=>{
                while(tcount > transcriptCount){
                  (<FormArray>this.transcripts.controls['transcriptInstitute']).push(this.buildInstituteItems('transcript',null,transcript_last_data.referenceNO,transcript_last_data.name,transcript_last_data.address,transcript_last_data.email,this.selectedDelivery));
                  tcount--;
                }
              },500)
            }

            if(this.verificationTypes.degreeCertificate){
              if(degree_last_data.referenceNO == null){
                if(transcript_last_data.referenceNO == null){
                  if( marklist_last_data.referenceNO != null){
                    degree_last_data = marklist_last_data;
                  }
                }else{
                  degree_last_data = transcript_last_data
                }
              }
              var dcount = 0;
              if(this.verificationTypes.sealedCover){

                dcount = this.verificationTypes.noOfCopies;
              }else if (this.verificationTypes.pickup) {
                dcount = this.verificationTypes.noOfPickup;
              } else {
                dcount = 1;
              }
              setTimeout(()=>{
                while(dcount > degreeCount){
                  (<FormArray>this.degrees.controls['degreeInstitute']).push(this.buildInstituteItems('degree',null,degree_last_data.referenceNO,degree_last_data.name,degree_last_data.address,degree_last_data.email,this.selectedDelivery));
                  dcount--;
                }
              },700)
            }

            if(this.verificationTypes.secondYear){
              if(secondYear_last_data.referenceNO == null){
                if(degree_last_data.referenceNO == null){
                  if(transcript_last_data.referenceNO == null){
                    if( marklist_last_data.referenceNO != null){
                      secondYear_last_data = marklist_last_data;
                    }
                  }else{
                    secondYear_last_data = transcript_last_data;
                  }
                }else{
                  secondYear_last_data = degree_last_data;
                }
              }
              var sycount = 0;
              if(this.verificationTypes.sealedCover){

                sycount = this.verificationTypes.noOfCopies;
              }else{
                sycount = 1;
              }
              setTimeout(()=>{
                while(sycount > secondYearCount){
                  (<FormArray>this.secondYears.controls['secondYearInstitute']).push(this.buildInstituteItems('secondYear',null,secondYear_last_data.referenceNO,secondYear_last_data.name,secondYear_last_data.address,secondYear_last_data.email,this.selectedDelivery));
                  sycount--;
                }
              },900)
            }
    
        },3000)
        this.validateDocumentDetails('institutes');
      }
    })
  }

  buildInstituteItems(type,id,refId,name,address,email,deliveryOption){
    if(deliveryOption == "Physical"){
      return new FormGroup({
        id : new FormControl(id),
        referenceNo: new FormControl(refId, Validators.required),
        name:new FormControl(name, Validators.required),
        address:new FormControl(address,Validators.required),
        email: new FormControl(email),
      })
    }else if(deliveryOption == "Digital"){
      return new FormGroup({
        id : new FormControl(id),
        referenceNo: new FormControl(refId, Validators.required),
        name:new FormControl(name, Validators.required),
        address:new FormControl(address),
        email: new FormControl(email,[Validators.required, Validators.pattern(this.emailValidate)]),
      })
    }else{
      return new FormGroup({
        id : new FormControl(id),
        referenceNo: new FormControl(refId, Validators.required),
        name:new FormControl(name, Validators.required),
        address:new FormControl(address),
        email: new FormControl(email),
      })
    }
  }

  displayFn(courseName) {
    return courseName ? courseName : '';
  }

  displayFn1(semester) {
    return semester ? semester : '';
  }

  displayFn2(collegeName) {
    return collegeName ? collegeName : '';
  }
  
  getCourseDetails(courseName,event){
    if(courseName){
      this.processApi.getCourseDetails(courseName,event.value).subscribe(data=>{
        this.courseDetails = data['data'];
      })
    }
    if (event.value == 'Semester') {
      this.patternType += "Semester";
    } else {
      this.patternType += "Year";
    }
  }
  
  onPatternSelection(event:any){
    this.patternValue=event.value;
    if(this.patternValue){
      this.processApi.getCourseDetails(this.courseName,this.patternSup).subscribe((data:any)=>{
        this.valueOfPattern = data['data']
      })
    }
  }
    patternSup(arg0: string, patternSup: any) {
      throw new Error('Method not implemented.');
    }
  public findInvalidControls(controls) {
    const invalid = [];

    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  imagePopup(imagename,document_type){
    this.dialogService.open(DocumentViewer, {
      context: {
      arr : imagename,
      user_id : this.user_id,
      type : document_type
      },
    });
  }

  selectDeliveryOption(){
    this.viewInstitute = true;
    
  }

  saveInstituteDetails(type,index){
    var instituteData;
    var control;
    this.loader = true;
   switch(type){
    case "marksheet":{
      if((<FormArray>this.marksheets.controls['marksheetInstitute']).at(index).status == 'VALID'){
        control =  this.marksheets.get('marksheetInstitute') as FormArray;
        instituteData = control.at(index).value;
      }
    }
    break;
    case "transcript":{
      if((<FormArray>this.transcripts.controls['transcriptInstitute']).at(index).status == 'VALID'){
        control =  this.transcripts.get('transcriptInstitute') as FormArray;
        instituteData = control.at(index).value;
      }
    }
    break;
    case "degree":{
      if((<FormArray>this.degrees.controls['degreeInstitute']).at(index).status == 'VALID'){
        control =  this.degrees.get('degreeInstitute') as FormArray;
        instituteData = control.at(index).value;
      }
    }
    break;
    case "secondYear":{
      if((<FormArray>this.secondYears.controls['secondYearInstitute']).at(index).status == 'VALID'){
        control =  this.secondYears.get('secondYearInstitute') as FormArray;
        instituteData = control.at(index).value;
      }
    }
    break;
   }
    if(this.selectedDelivery && this.selectedDeliveryMode){
      this.agentProcessApi.saveInstitutionDetails(type,instituteData,this.selectedDelivery,this.selectedDeliveryMode,this.user_id).subscribe(data=>{
        if(data['status'] == 200){
          this.toastrService.show('Institute details saved successful','SUCCESS', { 'duration':3000} );
          this.getInstitutionData();
        }
      })

      
    }else{
      this.toastrService.show('Please select delivery option and mode','DANGER', { 'duration':3000} );
      this.getInstitutionData();
    }
    this.loader = false;

  }

  getPreviewData(){
    this.agentProcessApi.getPreviewData(this.user_id).subscribe(data=>{
      this.personalDetails = data['data']['personalDetails'];
      this.verificationDetails = data['data']['verificationDetails'];
      this.marksheetDetails = data['data']['marksheetDetails'];
      this.secondYearDetails = data['data']['secondYearDetails'];
      this.transcriptDetails = data['data']['transcriptDetails'];
      this.degreeDetails = data['data']['degreeDetails'];
      this.deliveryOptions = data['data']['deliveryOptions'];
      this.marksheetInstituteDetails = data['data']['marksheetInstitute'];
      this.transcriptInstituteDetails = data['data']['transcriptInstitute'];
      this.degreeInstituteDetails = data['data']['degreeInstitute'];
      this.secondYearInstituteDetails = data['data']['secondYearInstitute'];
      this.language = this.personalDetails.language
    })
  }

  proceedforpayment(){
    this.dialogService.open(Firstpaymentdialog, {
      context:{
        source : 'agent',
        user_id : this.user_id
      }
    })
  }

  deleteDocument(id,type){
    this.agentProcessApi.deletefile(id,type,this.user_id).subscribe(data=>{
      var duration = 2000;
      if(data['status']==200){
        this.toastrService.success('File deleted' ,'SUCCESS', { duration} );
        this.ngOnInit();
      }else{
        this.toastrService.show('File Not deleted' ,'DANGER', { duration} );
      }
    })
  }


  deleteDetails(id,type){
    this.agentProcessApi.deletedoc(id,type,this.user_id).subscribe(data=>{
      var duration=2000;
      if(data['status']==200){
        this.toastrService.success('Details deleted','SUCCESS',{duration});
        this.ngOnInit();
      }else{
        this.toastrService.show('Details not deleted','DANGER',{duration});
      }
    })
  }

  
  Marksheets() {
    this.marksheetss = true;
    this.transcriptss = false;
    this.degree = false;
    this.secondYearss = false;
    this.aadharss = false;
  }

  Transcripts() {
    this.marksheetss = false;
    this.transcriptss = true;
    this.degree = false;
    this.secondYearss = false;
    this.aadharss = false;
  }

  Degree() {
    this.marksheetss = false;
    this.transcriptss = false;
    this.degree = true;
    this.secondYearss = false;
    this.aadharss = false;
  }

  secondYear() {
    this.marksheetss = false;
    this.transcriptss = false;
    this.degree = false;
    this.secondYearss = true;
    this.aadharss = false;
  }

  InMarksheets() {
    this.Inmarksheetss = true;
    this.Intranscriptss = false;
    this.Indegree = false;
    this.InsecondYearss = false;
    this.Inaadharss = false;
  }

  InTranscripts() {
    this.Inmarksheetss = false;
    this.Intranscriptss = true;
    this.Indegree = false;
    this.InsecondYearss = false;
    this.Inaadharss = false;
  }

  InDegree() {
    this.Inmarksheetss = false;
    this.Intranscriptss = false;
    this.Indegree = true;
    this.InsecondYearss = false;
    this.Inaadharss = false;
  }

  InsecondYear() {
    this.Inmarksheetss = false;
    this.Intranscriptss = false;
    this.Indegree = false;
    this.InsecondYearss = true;
    this.Inaadharss = false;
  }

  aadharcard() {
    this.marksheetss = false;
    this.transcriptss = false;
    this.degree = false;
    this.secondYearss = false;
    this.aadharss = true;
  }

  setToOtherFields(type, fieldValue, i, field) {
    var count = 0;
    if (this.verificationTypes.sealedCover) {
      count = this.verificationTypes.noOfCopies;
    } else if (this.verificationTypes.pickup) {
      count = this.verificationTypes.noOfPickup;
    } else {
      count = 1;
    }
    if (field == 'course') {
      if (type == 'marksheet') {
        if (this.verificationTypes.marksheet) {
          for (var next = i + 1; next <= this.verificationTypes.noOfMarksheet - 1; next++) {
            (<FormArray>this.marksheets.controls['marksheet']).at(next).patchValue({ courseName: fieldValue });
            this.manageNameControl(next, 'marksheet');

          }

          if(((<FormArray>this.marksheets.controls['marksheet']).at(i).value.courseName.includes('Master in Business Administration') || 
          (<FormArray>this.marksheets.controls['marksheet']).at(i).value.courseName.includes('Master of Business Administration'))
          && ((<FormArray>this.marksheets.controls['marksheet']).at(i).value.semester === 'Semester IV' ||
          (<FormArray>this.marksheets.controls['marksheet']).at(i).value.semester === 'Second Year')){
            var passingYear = new Date((<FormArray>this.marksheets.controls['marksheet']).at(i).value.passingMonthYear).getFullYear();
            if(passingYear >=1995 && passingYear <=2003){
              (<FormArray>this.marksheets.controls['marksheet']).at(i).patchValue({'mbaCheck':true});
            }else{
              (<FormArray>this.marksheets.controls['marksheet']).at(i).patchValue({'mbaCheck':false});
            }
          }

        }
      } else if (type == 'transcript') {
        var courseName = (<FormArray>this.transcripts.controls['transcript']).at(i).value.courseName;
        var seatNo = (<FormArray>this.transcripts.controls['transcript']).at(i).value.seatNo;
        var passingMonthYear = (<FormArray>this.transcripts.controls['transcript']).at(i).value.passingMonthYear;
        var result = (<FormArray>this.transcripts.controls['transcript']).at(i).value.result;
        if (this.verificationTypes.degreeCertificate) {
          for (next = 0; next < this.verificationTypes.noOfDegree; next++) {
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ courseName: courseName });
            this.manageNameControl(next, 'degree');
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ seatNo: seatNo });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ passingMonthYear: new Date(passingMonthYear) });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ result: new Date(result) });
          }
        }
      }
    } else if (field == 'sem_year') {
      var sem_yearLength = this.courseDetails.length - 1;
      if (fieldValue == this.courseDetails[sem_yearLength].term_name) {
        var courseName = (<FormArray>this.marksheets.controls['marksheet']).at(i).value.courseName;
        var seatNo = (<FormArray>this.marksheets.controls['marksheet']).at(i).value.seatNo;
        var passingMonthYear = (<FormArray>this.marksheets.controls['marksheet']).at(i).value.passingMonthYear;
        var result = (<FormArray>this.marksheets.controls['marksheet']).at(i).value.result;
        if(((<FormArray>this.marksheets.controls['marksheet']).at(i).value.courseName.includes('Master in Business Administration') || 
          (<FormArray>this.marksheets.controls['marksheet']).at(i).value.courseName.includes('Master of Business Administration'))
          && ((<FormArray>this.marksheets.controls['marksheet']).at(i).value.semester === 'Semester IV' ||
          (<FormArray>this.marksheets.controls['marksheet']).at(i).value.semester === 'Second Year')){
            var passingYear = new Date((<FormArray>this.marksheets.controls['marksheet']).at(i).value.passingMonthYear).getFullYear();
            if(passingYear >=1995 && passingYear <=2003){
              (<FormArray>this.marksheets.controls['marksheet']).at(i).patchValue({'mbaCheck':true});
            }else{
              (<FormArray>this.marksheets.controls['marksheet']).at(i).patchValue({'mbaCheck':false});
            }
          }
        if (this.verificationTypes.transcript) {
          for (next = 0; next < this.verificationTypes.noOfTranscript; next++) {
            (<FormArray>this.transcripts.controls['transcript']).at(next).patchValue({ courseName: courseName });
            this.manageNameControl(next, 'transcript');
            (<FormArray>this.transcripts.controls['transcript']).at(next).patchValue({ seatNo: seatNo });
            (<FormArray>this.transcripts.controls['transcript']).at(next).patchValue({ passingMonthYear: new Date(passingMonthYear) });
            (<FormArray>this.transcripts.controls['transcript']).at(next).patchValue({ result: new Date(result) });
          }
        }
        if (this.verificationTypes.degreeCertificate) {
          for (next = 0; next < this.verificationTypes.noOfDegree; next++) {
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ courseName: courseName });
            this.manageNameControl(next, 'degree');
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ seatNo: seatNo });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ passingMonthYear: new Date(passingMonthYear) });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ result: new Date(result) });
          }
        }
      }
    } else if (field == 'refNO') {
      var refNo;
      if (type == 'marksheet') {
        refNo = (<FormArray>this.marksheets.controls['marksheetInstitute']).at(i).value.referenceNo;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.marksheets.controls['marksheetInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.transcript)
            (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ referenceNo: refNo });
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ referenceNo: refNo });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
      } else if (type == 'transcript') {
        refNo = (<FormArray>this.transcripts.controls['transcriptInstitute']).at(i).value.referenceNo;
        for (next = i + 1; next <= count; next++) {
          (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ referenceNo: refNo });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
      } else if (type == 'degree') {
        refNo = (<FormArray>this.degrees.controls['degreeInstitute']).at(i).value.referenceNo;
        for (next = i + 1; next <= count; next++) {
          (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
      } else if (type == 'secondYear') {
        refNo = (<FormArray>this.secondYears.controls['secondYearInstitute']).at(i).value.referenceNo;
        for (next = i + 1; next <= count; next++) {
          (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ referenceNo: refNo });
        }
      }

    } else if (field == 'instName') {
      var instName;
      if (type == 'marksheet') {
        instName = (<FormArray>this.marksheets.controls['marksheetInstitute']).at(i).value.name;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.marksheets.controls['marksheetInstitute']).at(next).patchValue({ name: instName });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.transcript)
            (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ name: instName });
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ name: instName });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ name: instName });
        }
      } else if (type == 'transcript') {
        instName = (<FormArray>this.transcripts.controls['transcriptInstitute']).at(i).value.name;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ name: instName });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ name: instName });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ name: instName });
        }
      } else if (type == 'degree') {
        instName = (<FormArray>this.degrees.controls['degreeInstitute']).at(i).value.name;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ name: instName });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ name: instName });
        }
      } else if (type == 'secondYear') {
        instName = (<FormArray>this.secondYears.controls['secondYearInstitute']).at(i).value.name;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ name: instName });
        }
      }
    } else if (field == 'address') {
      var address;
      if (type == 'marksheet') {
        address = (<FormArray>this.marksheets.controls['marksheetInstitute']).at(i).value.address;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.marksheets.controls['marksheetInstitute']).at(next).patchValue({ address: address });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.transcript)
            (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ address: address });
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ address: address });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ address: address });
        }
      } else if (type == 'transcript') {
        address = (<FormArray>this.transcripts.controls['transcriptInstitute']).at(i).value.address;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ address: address });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ address: address });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ address: address });
        }
      } else if (type == 'degree') {
        address = (<FormArray>this.degrees.controls['degreeInstitute']).at(i).value.address;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ address: address });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ address: address });
        }
      } else if (type == 'secondYear') {
        address = (<FormArray>this.secondYears.controls['secondYearInstitute']).at(i).value.address;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ address: address });
        }
      }
    } else if (field == 'email') {
      var email;
      if (type == 'marksheet') {
        email = (<FormArray>this.marksheets.controls['marksheetInstitute']).at(i).value.email;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.marksheets.controls['marksheetInstitute']).at(next).patchValue({ email: email });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.transcript)
            (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ email: email });
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ email: email });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ email: email });
        }
      } else if (type == 'transcript') {
        email = (<FormArray>this.transcripts.controls['transcriptInstitute']).at(i).value.email;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.transcripts.controls['transcriptInstitute']).at(next).patchValue({ email: email });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.marksheet)
            (<FormArray>this.marksheets.controls['marksheetInstitute']).at(next).patchValue({ email: email });
          if (this.verificationTypes.degreeCertificate)
            (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ email: email });
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ email: email });
        }
      } else if (type == 'degree') {
        email = (<FormArray>this.degrees.controls['degreeInstitute']).at(i).value.email;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.degrees.controls['degreeInstitute']).at(next).patchValue({ email: email });
        }
        for (next = 0; next < count; next++) {
          if (this.verificationTypes.secondYear)
            (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ email: email });
        }
      } else if (type == 'secondYear') {
        email = (<FormArray>this.secondYears.controls['secondYearInstitute']).at(i).value.email;
        for (next = i + 1; next < count; next++) {
          (<FormArray>this.secondYears.controls['secondYearInstitute']).at(next).patchValue({ email: email });
        }
      }
    } else if (field == 'college') {
      if (type == 'marksheet') {
        if (this.verificationTypes.marksheet) {
          for (var next = i + 1; next <= this.verificationTypes.noOfMarksheet - 1; next++) {
            (<FormArray>this.marksheets.controls['marksheet']).at(next).patchValue({ collegeName: fieldValue });
            this.manageNameControl(next, 'marksheet');

          }
        }
      } else if (type == 'transcript') {
        var collegeName = (<FormArray>this.transcripts.controls['transcript']).at(i).value.collegeName;
        var courseName = (<FormArray>this.transcripts.controls['transcript']).at(i).value.courseName;
        var seatNo = (<FormArray>this.transcripts.controls['transcript']).at(i).value.seatNo;
        var passingMonthYear = (<FormArray>this.transcripts.controls['transcript']).at(i).value.passingMonthYear;
        if (this.verificationTypes.degreeCertificate) {
          for (next = 0; next < this.verificationTypes.noOfDegree; next++) {
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ collegeName: collegeName });
            this.manageNameControl(next, 'degree');
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ courseName: courseName });
            this.manageNameControl(next, 'degree');
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ seatNo: seatNo });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ passingMonthYear: new Date(passingMonthYear) });
          }
        }
      }
    } else if (field == 'courseType') {
      if (type == 'marksheet') {
        if (this.verificationTypes.marksheet) {
          for (var next = i + 1; next <= this.verificationTypes.noOfMarksheet - 1; next++) {
            (<FormArray>this.marksheets.controls['marksheet']).at(next).patchValue({ courseType: fieldValue });

          }
        }
      } else if (type == 'transcript') {
        var courseName = (<FormArray>this.transcripts.controls['transcript']).at(i).value.courseName;
        var courseType = (<FormArray>this.transcripts.controls['transcript']).at(i).value.courseType;
        var seatNo = (<FormArray>this.transcripts.controls['transcript']).at(i).value.seatNo;
        var passingMonthYear = (<FormArray>this.transcripts.controls['transcript']).at(i).value.passingMonthYear;
        var result = (<FormArray>this.transcripts.controls['transcript']).at(i).value.result;
        if (this.verificationTypes.degreeCertificate) {
          for (next = 0; next < this.verificationTypes.noOfDegree; next++) {
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ courseName: courseName });
            this.manageNameControl(next, 'degree');
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ courseType: courseType });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ seatNo: seatNo });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ passingMonthYear: new Date(passingMonthYear) });
            (<FormArray>this.degrees.controls['degree']).at(next).patchValue({ result: new Date(result) });
          }
        }
      }
    }
  }

  videoPopup(steppernum){
    if(steppernum == 1){
      this.displayvideo1 = true;
    }
    if(steppernum == 2){
      this.displayvideo2 = true;
    }
    if(steppernum == 3){
      this.displayvideo3 = true;
    }
  }

  // downloadLetter(){
	// 	var file_name = 'NOC letter.docx'
	// 	this.processApi.downloadTemplate().subscribe(data => {
	// 		saveAs(data,file_name); 
	// 	})
	// }

  deselectTranscript(event) {
    if (event.value == 'External') {
      var result = this.verificationData.some(data=>(data.type == "transcript"));
      if(result == true){
        this.loader = true;
        var checked = { checked: false }
        this.selectVerificationType(checked, 'transcript');
        this.saveVerificationTypes('deselectTranscript');
        this.setDocumentTab();
        this.confirmationService.confirm({
          message: 'As you are external student, you cannot select transcript for verification',
          header: 'Invalid Selection',
          icon: 'pi pi-info-circle',
          rejectVisible: false,
          acceptLabel: 'Ok'
        })
        this.loader = false;
      }
    }
  }

  validateDocumentDetails(type) {
    this.agentProcessApi.validateDocumentDetails(type,this.user_id).subscribe(data => {
       var validateData = data['data'];
       
       if (validateData.marksheet == false) {
         this.Marksheets();
        //  if(this.marksheetData == true)
         this.InMarksheets();
       } else if (validateData.transcript == false) {
         this.Transcripts();
         this.InTranscripts();
       } else if (validateData.degreeCertificate == false) {
         this.Degree();
         this.InDegree();
       } else if (validateData.secondYear == false) {
         this.secondYear();
         this.InsecondYear();
       } else {
         this.setDocumentTab();
       }
     })
  }

  selectColleges(course) {
    var result = this.collegeData.some(option => (option.college_name == course));
    if(!result) {
      this.toastrService.danger('Error', 'Please select College from College list', { duration: 6000 });
      //this.college = undefined
    }else{
      this.college = course;
    }
  }

  selectColleges_edit(event){
  
    this.selectedCollege = event.target.value;
    const selectedCollegeEntry = this.collegeData.find(college => college.college_name === this.selectedCollege);
      const selectedCollegeId = selectedCollegeEntry.id;
      this.collegeId  = selectedCollegeEntry.id
      const filteredCollegeCourses = this.collegeCourse.filter(course => course.college_id === selectedCollegeId);
      const courseIds = filteredCollegeCourses.map(course => course.course_id);
      this.filteredCourses =this.courseData.filter(course => courseIds.includes(course.id));

    if(event.target.value !=''){
      var filter_result =event.target.value 
     // this.college =  event.target.value 
      if (filter_result.length > 10) {
        const filterValue = event.target.value
        this.selectColleges(filterValue) 
      }  
      
    }    
  }
  selectCourse_edit(event){
    this.selectedcourse = event.target.value;
    const selectedCourseEntry = this.courseData.find(course => course.course_name === this.selectedcourse);
    this.courseId  = selectedCourseEntry.id
  
    this.coursevalue = this.courseData.some(course =>(course.course_name == event.target.value))
    setTimeout(()=>{
      if(this.coursevalue == false){
        this.toastrService.danger('Error', 'Please select course from course list', { duration: 6000 });
        this.coursename=false
      }else{
        this.coursename=true
      }
    },4000)
  }

  verify(i,type){
    if (type == 'marksheet'){
    var control = this.marksheets.get('marksheet') as FormArray;
    var marksheet = control.at(i).value;
    }else  if (type == 'transcript'){
      var control = this.transcripts.get('transcript') as FormArray;
      var transcript = control.at(i).value;
    }else if (type == 'degree'){
      var control = this.degrees.get('degree') as FormArray;
      var degree = control.at(i).value;
    }
    this.agentProcessApi.verifyMarksheetPrn(marksheet,transcript,degree,this.user_id).subscribe(data => {
       if(data['status'] == 400){
        this.toastrService.show('error',"PRN number doesn't match. Please fill in all details.", { duration: 10000 });
        this.getDocumentDetails();
     } else {
      this.getDocumentDetails();
     }
   
    })
  
  }

}